<template>
    <article class="mini-product-card">
        <nuxt-link :to="to" class="inner">
            <div class="image-container">
                <lazy-image
                    :src="image.src"
                    :alt="image.alt"
                    :width="image.width"
                    :height="image.height"
                />
            </div>
            <div class="info-container">
                <strong
                    class="name"
                    v-test:name
                >
                    {{ name }}
                </strong>
                <p
                    class="calories"
                    v-test:calories
                >
                    {{ calories }} {{ $snippet('kcal', 'kcal') }}
                </p>
            </div>
        </nuxt-link>
    </article>
</template>

<script>
    export default {
        name: 'mini-product-card',

        props: {
            name: {
                type: String,
                required: true,
                default: '',
            },

            calories: {
                type: [Number, String],
                required: true,
                default: null,
            },

            image: {
                type: Object,
                required: true,
                default: () => ({}),
            },

            to: {
                type: String,
                required: true,
                default: '',
            },
        },
    };
</script>

<style lang="scss" scoped>
    .inner {
        border: solid 1px primary-palette(1);
        border-radius: 30px;
        background-color: #ffffff;
        text-align: center;
        display: flex;
        flex-direction: column;

        &:hover,
        &:focus-visible,
        &:active {
            text-decoration: none;
            outline: 1px solid primary-palette(1);
            outline-offset: -2px;
            box-shadow: none;

            .name {
                color: primary-palette(1);
            }
        }
    }

    .image-container {
        padding: 10px;
    }

    .lazy-image {
        width: 100%;
        height: auto;
    }

    .info-container {
        margin: 0 auto;
        flex-grow: 1;
        display: flex;
        align-items: center;
        flex-direction: column;
        padding: 0 10px 5px;
    }

    .name {
        font-weight: bold;
        color: primary-palette(2);
        line-height: rem(20px);
        margin-bottom: 0;
    }

    .calories {
        color: secondary-palette(5);
        font-size: rem(14px);
        line-height: rem(18px);
        font-weight: 300;
        margin-top: auto;
        margin-bottom: 0;
    }
</style>
